// Lessons Index - lista wszystkich lekcji dla LessonsPage
import { day1Content, day4PlusPlaceholder } from './day1Content';
import { day2Content } from './day2Content';
import { day3Content } from './day3Content';
import { day4Content } from './day4Content';
import { day5Content } from './day5Content';
import { day6Content } from './day6Content';
import { day7Content } from './day7Content';
import { day8Content } from './day8Content';

// Generowanie placeholderów dla dni 8-30
const generatePlaceholders = () => {
  const placeholders = [];
  for (let i = 9; i <= 30; i++) {
    placeholders.push({
      day_number: i,
      title: `Dzień ${i}`,
      subtitle: "Wkrótce dostępne",
      duration: "10-15 min",
      status: "paywall",
      is_free: false
    });
  }
  return placeholders;
};

export const lessonsIndex = [
  { ...day1Content, is_free: true },
  { ...day2Content, is_free: true },
  { ...day3Content, is_free: true },
  { ...day4Content, is_free: false },
  { ...day5Content, is_free: false },
  { ...day6Content, is_free: false },
  { ...day7Content, is_free: false },
  { ...day8Content, is_free: false },
  ...generatePlaceholders()
];
